import { isSignedInAtom } from "@/hooks/authAtoms";
import { useAtom } from "jotai";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { Row } from "@/utils/bootstrap";
import Price from "../../../lib/Price";
import { PagesPaths } from "@/utils/functions/pages-paths";

import { useTranslation } from "@/hooks/localization/useTranslations";
import CartAuthSection from "./CartAuthSection";
import { useSearchParams } from "next/navigation";
import CartCheckoutSection from "./CartCheckoutSection";
import useSellingMode from "@/hooks/useSellingMode";

interface Props {
  total: number;
  mobile?: boolean;
  tax?: number;
}

const CartButtons: React.FC<Props> = ({ total, tax, mobile = false }) => {
  const t = useTranslation();
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isSignedIn] = useAtom(isSignedInAtom);
  const { enableCheckout } = useSellingMode();
  const checkoutPath = isSignedIn
    ? PagesPaths.userCheckout
    : PagesPaths.checkout;

  const goToAuthFromCart = () => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("fromCart", "true");
    return params.toString();
  };
  return (
    <div className="cart-btns w-100">
      <div className="total">
        <div className="total-title">{t.grand_total}</div>
        <Price price={{ value: total, className: "total-value" }} />
      </div>
      {!!tax && (
        <div className="cart-tax">
          <div>{t.tax}:</div>
          <Price price={{ value: tax! }} />
        </div>
      )}
      <Row className="m-0" style={{ gap: 12 }}>
        {enableCheckout ? (
          <CartCheckoutSection
            isMobile={mobile}
            onCheckOut={() => router.push(checkoutPath)}
            onContinueShopping={() => router.push("/")}
          />
        ) : (
          <CartAuthSection
            onRegister={() => {
              router.push(PagesPaths.register + "?" + goToAuthFromCart());
            }}
            onSignIn={() => {
              router.push(PagesPaths.signin + "?" + goToAuthFromCart());
            }}
          />
        )}
      </Row>
    </div>
  );
};

export default CartButtons;
